export const MAKE_REQUEST = "MAKE_REQUEST";
export const FAIL_REQUEST = "FAIL_REQUEST";
export const POST_COURSE_SUCCESS = "POST_COURSE_SUCCESS";

export const ADD_BASIC_INFORM_STATE = "ADD_BASIC_INFORM_STATE";
export const ADD_ENROLL_CODE = "ADD_ENROLL_CODE";
export const ADD_SECTIONS_STATE = "ADD_SECTIONS_STATE";
export const UPDATE_SECTIONS_STATE = "UPDATE_SECTIONS_STATE";
export const ADD_LESSON_STATE = "ADD_LESSON_STATE";
export const UPDATE_LESSON_STATE = "UPDATE_LESSON_STATE";
export const DELETE_LESSON_STATE = "DELETE_LESSON_STATE";
export const DELETE_SECTION_STATE = "DELETE_SECTION_STATE";

export const UPLOAD_VIDEO_CLOUDINARY_SUCCESS =
  "UPLOAD_VIDEO_CLOUDINARY_SUCCESS";

export const FINISH_LOADING = "FINISH_LOADING";
export const LOADING_PERCENTAGE = "LOADING_PERCENTAGE";
export const LOADING_PERCENTAGE_THUMBNAIL = "LOADING_PERCENTAGE_THUMBNAIL";
export const RESET_LOADING_PERCENTAGE = "RESET_LOADING_PERCENTAGE";

export const GET_ALL_COURSES = "GET_ALL_COURSES";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const COURSE_DETAIL = "COURSE_DETAIL";
